import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferRedemptionsService } from '../services/offer-redemptions.service';
import { SortableComponent } from '../../core/sortable/sortable.component';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { LocationService } from '../../locations/services/location.service';
import { config } from '../../app.config';
import * as moment from 'moment';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'ch-offer-redemptions-listing',
  templateUrl: './offer-redemptions-listing.component.html',
  styleUrls: ['./offer-redemptions-listing.component.css'],
})
export class OfferRedemptionsListingComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};
  public locations: any[] = [];
  public exportingExcel: boolean;
  private filterFields: string[] = ['locationId', 'search', 'startDate', 'endDate'];

  public loading: boolean;

  constructor(
    private offerRedemptionsService: OfferRedemptionsService,
    private locationService: LocationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private authDataStorageService: AuthDataStorageService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(`Offer Redemptions | CODE Hospitality CMS`);
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        let pageParams = this.routeHelperService.getValidatedParams(params);
        this.pageParams = this.filterPageParams(pageParams);
        this.loadItems(this.pageParams);
      });

    this.locationService.getLocationData().then((resp: any[]) => {
      resp.unshift({
        id: '',
        value: 'All Locations',
      });
      this.locations = resp;
    });
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private filterPageParams(params) {
    if (!params.startData && !params.endDate) {
      params.startDate = moment()
        .subtract(1, 'month')
        .format('YYYY-MM-DD');
      params.endDate = moment().format('YYYY-MM-DD');
    }

    return params;
  }

  public downloadReport() {
    const url: string = `${this.apiUrl}offers/redemptions/report?${this.queryString}`;

    this.exportingExcel = true;
    this.downloadUrlFile(url, `offer-redemptions-report-${moment().format('DD-MM-YYYY')}.xlsx`);
  }

  private downloadUrlFile(url, filename) {
    fetch(url, {})
      .then(r => r.blob())
      .then((blob: any) => {
        const newBlob = new Blob([blob], { type: 'application/pdf' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        const d = new Date();
        link.download = filename;
        link.click();
        this.exportingExcel = false;
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      });
  }

  public datepickerChanged(value) {
    let startDateAsString = moment(value.start._d).format('YYYY-MM-DD');
    let endDateAsString = moment(value.end._d).format('YYYY-MM-DD');

    this.filterSearch({
      startDate: startDateAsString,
      endDate: endDateAsString,
    });
  }

  public locationChanged(event) {
    if (!event || !event.target || !event.target.value) {
      return;
    }
    this.filterSearch({
      locationId: event.target.value,
    });
  }

  public search(event) {
    this.filterSearch({
      search: event,
    });
  }

  private filterSearch(data) {
    const result = {};
    for (let i of this.filterFields) {
      result[i] = null != data[i] ? data[i] : this.pageParams[i];
    }

    this.router.navigate([], { queryParams: result });
  }

  public onSort(data) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order,
    });
  }

  public onPageChanged(page) {
    this.queryParams({
      pageNumber: page.pageNumber,
      pageSize: page.pageSize,
    });
  }

  private queryParams(params) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(data) {
    this.loading = true;
    this.offerRedemptionsService.getOfferRedemptions(data).subscribe(result => {
      const jsonData = result.json();
      this.items = jsonData.items;
      this.totalItems = jsonData.totalItems;
      this.loading = false;
    });
  }

  get queryString() {
    return this.routeHelperService.buildQueryString(
      {
        'x-auth-token': this.authDataStorageService.getSessionTokenFromStorage(),
        ...this.pageParams,
      },
      ['pageSize', 'pageNumber']
    );
  }

  get apiUrl() {
    return config.api_url;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offer-redemptions/offer-redemptions-listing/offer-redemptions-listing.component.ts